import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

function SheetPoint({ image = "", title = "", text = "", smallTitle = "", smallTitleText = "", }) {
  return (
    <Box sx={{
      display: 'flex',
      gap: '1.5rem',
      width: '100%',
      height: '100%',
    }}>

      {image &&
        <Box sx={{ color: "white", }}>
          <Box
            component="img"
            src={image}
            sx={{
              height: "4.8rem",
              width: "4.8rem",
              display: "flex",
              justifyContent: "center",
              objectFit: "contain",
            }}
            alt=""
          />
        </Box>}

      <Box>
        <Typography
          sx={{
            fontSize: "2.4rem",
            fontWeight: 700,
            color: "white",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: "1.6rem",
            fontWeight: 400,
            color: "#FFFFFFBF"
          }}
        >
          {text}
        </Typography>

        <Typography
          sx={{
            fontSize: "1.6rem",
            fontWeight: 400,
            color: "#FFFFFFBF"
          }}
        >
          {smallTitle}
        </Typography>

        <Typography
          sx={{
            fontSize: "2rem",
            fontWeight: 700,
            color: "white",
            maxWidth: "30ch"
          }}
        >
          {smallTitleText}
        </Typography>
      </Box>
    </Box>
  );
}

SheetPoint.propTypes = {
  window: PropTypes.func,
};

export default SheetPoint;